import { Table } from "@mantine/core";
import { formatNZD } from "common/utils";
import { useNavigate } from "react-router-dom";
import { ProductSearchSummary } from "types/model.types";

interface ProductSearchResultCardProps {
  p: ProductSearchSummary;
  onClose?: () => void;
}

const ProductSearchResultCard: React.FC<ProductSearchResultCardProps> = ({
  p,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/admin/enquire-products?id=${p.id}`);
    onClose && onClose?.();
  };

  return (
    <Table.Tr
      onClick={handleClick}
      style={{ cursor: "pointer" }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#f8f9fa")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
    >
      <Table.Td>{p.id}</Table.Td>
      <Table.Td>{p.title}</Table.Td>
      <Table.Td className="money">{formatNZD(p.sellPrice1)}</Table.Td>
      <Table.Td className="money">{formatNZD(p.sellPrice2)}</Table.Td>
      <Table.Td>{p.barcode}</Table.Td>
      <Table.Td>{p.closed ? "Yes" : "No"}</Table.Td>
    </Table.Tr>
  );
};

export default ProductSearchResultCard;
